/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react';
import propTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { isBlank } from 'lib/string';
import { utcToPtDateString } from 'lib/date';

import styles from './NodeInfo.css';

const DATE_TIME_FORMAT = 'YYYY-MM-DD hh:mm:ss a z';

/**
 * render seo settings
 * @param {object} props - component props
 * @param {object[]} props.node - node information
 * @returns {React.Component} form fields
 */
const NodeInfo = ({ node }) => (
  <div className="p-4">
    {isEmpty(node) && (
      <div data-test-id="nodeInfo-no-info">No Node Information from Compass is available.</div>
    )}
    {!isEmpty(node) &&
      node.map((nodeObj, index) => (
        <div key={index}>
          {!isEmpty(nodeObj) && (
            <div className={styles.wrapper} key={index} data-test-id="nodeInfo-node-info">
              {!isBlank(nodeObj.Name) && (
                <Fragment>
                  <div className={styles.header}>Node</div>
                  <div className={styles.detail} data-test-id="nodeInfo-name">
                    {nodeObj.Name}
                  </div>
                </Fragment>
              )}
              <div className={styles.header}>Route</div>
              <div className={styles.detail} data-test-id="nodeInfo-route">
                {nodeObj.Route}
              </div>
              <div className={styles.header}>Content Live Date</div>
              <div className={styles.detail} data-test-id="nodeInfo-startDate">
                {utcToPtDateString(nodeObj.StartDate, DATE_TIME_FORMAT)}
              </div>
              {!isBlank(nodeObj.EndDate) && (
                <Fragment>
                  <div className={styles.header}>Content End Date</div>
                  <div className={styles.detail} data-test-id="nodeInfo-endDate">
                    {utcToPtDateString(nodeObj.EndDate, DATE_TIME_FORMAT)}
                  </div>
                </Fragment>
              )}
            </div>
          )}
        </div>
      ))}
  </div>
);

NodeInfo.propTypes = {
  node: propTypes.array.isRequired
};

export default NodeInfo;
